import React from "react";
import { Power } from "lucide-react";

import { Switch } from "../../../components/ui/switch";

export default function CartaoLigado({ ativa, onAtiva }) {
  return (
    <section data-e2e="cartao-status-recuperador"
      className={`rounded-2xl border-2 p-4 sm:p-5 transition-colors ${ativa ? "border-emerald-500/50 bg-gradient-to-r from-emerald-500/15 via-emerald-500/5 to-transparent" : "border-border bg-card"}`}>
      <div className="flex items-center gap-4">
        <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 ${ativa ? "bg-emerald-500 text-white shadow-lg shadow-emerald-500/30" : "bg-muted text-muted-foreground"}`}>
          <Power className="w-6 h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-lg font-bold leading-tight">{ativa ? "Recuperador ligado" : "Recuperador desligado"}</p>
          <p className="text-sm text-muted-foreground">
            {ativa ? "A CLEO está chamando de volta quem para no meio do pedido." : "Ninguém recebe mensagem de recuperação enquanto estiver desligado."}
          </p>
        </div>
        <Switch checked={ativa} onCheckedChange={onAtiva} aria-label="Ligar Recuperador de Vendas" className="scale-125 mr-1" />
      </div>
    </section>
  );
}
